import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getResultsSuccess,
  initGetResults,
  initSaveInterestedCareer,
  initSetResults,
} from "../redux/actions/scenariosActions";
import { LocalStorage } from "../common/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import { initGetProfile } from "../redux/actions";
import { authIsAuthenticated } from "../redux/selectors/authSelectors";

const useResults = (resultsPage) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isErrorModalOpened, setIsErrorModalOpened] = useState(false);
  const [isSavedCareer, setIsSavedCareer] = useState(false)
  const { profile } = useSelector((state) => state.profileReducer);
  const { results, isLoading, isSetResultsSuccessLoaded, error, showLoader } = useSelector(
    (state) => state.scenariosReducer
  );

  // useEffect(() => {
  //   if (results_detail?.id) {
  //     const matchedItem = results?.find((el) => el.id === results_detail.id);
  //     setChosenItem({ ...matchedItem, interested: results_detail.interested });
  //     // setIsSavedCareer(false)
  //   }
  // }, [results_detail?.interested])

  const [chosenItem, setChosenItem] = useState({
    id: "",
    text: "",
    ai: "",
    score: null,
  });

  const [selectedItems, setSelectedItems] = useState([]);
  const [isSuccessModalOpened, setIsSuccessModalOPened] = useState(false);
  const isAuth = useSelector((state) => authIsAuthenticated(state));
  useEffect(() => {
    const storedAnswers = LocalStorage.getFromLocalStorage("scenarios");
    if (!storedAnswers && !isAuth) {
      resultsPage && navigate("/signin?redirect=/results");
    } else {
      dispatch(initGetResults());
      dispatch(initGetProfile());
    }
  }, [isAuth, resultsPage, navigate, dispatch]);
  useEffect(() => {
    if (error) {
      setIsErrorModalOpened(error?.detail);
    }
  }, [error]);
  /** Results page: AI recommendations are filled asynchronously (Celery). Poll until we have 10 or user leaves. */
  useEffect(() => {
    if (!resultsPage) return;
    if (results?.length >= 10) return;

    const intervalMs = 4000;
    const poll = () => {
      dispatch(initGetResults({ keepPrevious: true }));
    };
    const id = setInterval(poll, intervalMs);
    return () => clearInterval(id);
  }, [resultsPage, results?.length, dispatch]);
  const handleModalOpen = (id) => {
    setIsSavedCareer(false)
    setIsModalOpened(true);
    setChosenItem(() => {
      return {
        ...results?.find((el) => id === el.id),
        // score: null,
      };
    });
  };
  const closeModal = (id) => {
    const recommendId = id || chosenItem.id
    setIsSavedCareer(false)
    setIsModalOpened(false);
    setChosenItem("");
    handleUpdateResult(recommendId)
    chosenItem.score &&
      dispatch(
        initSetResults({
          id: recommendId,
          score: chosenItem.score,
          booked: false,
        })
      );
  };
  const handleUpdateResult = (id) => {
    const res = results.map((items) => {
      if (items.id === id) {
        items = {
          ...items,
          score: chosenItem.score,
        }
      }
      return items
    })
    dispatch(getResultsSuccess(res))
  }
  const handlescore = (rate) => {
    setChosenItem({
      ...chosenItem,
      score: rate,
    });
    let item = {
      ...chosenItem,
      score: rate,
    };
    const newSelectedItems = selectedItems.filter((el) => {
      if (el.id === item.id) {
        return false;
      } else {
        return true;
      }
    });
    setSelectedItems([...newSelectedItems, item]);
  };

  const handleBack = (id) => {
    chosenItem.score && dispatch(
        initSetResults({
          id: id || chosenItem.id,
          score: chosenItem.score,
          booked: false,
        })
      );
    navigate(-1);
  };

  const handleBook = (id, booked = true) => {
    setIsSavedCareer(false)
    setIsModalOpened(false);
    setIsSuccessModalOPened(true);
    if (profile.pricing_plan || profile.affiliate_code) {
      const recommendId = id || chosenItem.id
      handleUpdateResult(recommendId)
      dispatch(
        initSetResults({
          id: recommendId,
          score: chosenItem.score ? chosenItem.score : 0,
          booked: booked,
        })
      );
    } else {
      navigate("/pricingplan");
    }
  };
  const handleSaveCareer = (val, careerId) => {
    const id = careerId || chosenItem?.id;
    if (!id) return;
    setChosenItem((prevState) => {
      if (prevState?.id && prevState.id !== id) return prevState;
      return {
        ...prevState,
        interested: val,
      };
    });
    setIsSavedCareer(true);
    dispatch(initSaveInterestedCareer({ interested: val, id }));
    setTimeout(() => {
      setIsSavedCareer(false);
    }, 3000);
  };

  const persistSortDecision = (careerId, decision) => {
    const id = careerId || chosenItem?.id;
    if (!id || !decision) return;
    const interested = decision === "save";
    setChosenItem((prevState) => {
      if (prevState?.id && prevState.id !== id) return prevState;
      return {
        ...prevState,
        interested,
        sort_decision: decision,
      };
    });
    dispatch(
      initSaveInterestedCareer({
        interested,
        id,
        sort_decision: decision,
      })
    );
  };

  const persistScore = (careerId, score) => {
    if (!careerId || score == null) return;
    dispatch(
      initSetResults({
        id: careerId,
        score,
        booked: false,
      })
    );
  };
  useEffect(() => {
    if (isSetResultsSuccessLoaded) {
      if (resultsPage) {
        // setIsSuccessModalOPened(true);
      }
      if (results?.length) {
        // LocalStorage.removeFromLocalStorage("scenarios");
      }
    }
  }, [isSetResultsSuccessLoaded, results]);

  const closeSuccessModal = () => {
    if (pathname.includes("profile")) {
      navigate("/profile/recommendations");
    }
    setIsSuccessModalOPened(false);
  };
  return {
    results,
    isModalOpened,
    chosenItem,
    isSuccessModalOpened,
    selectedItems,
    isErrorModalOpened,
    isSavedCareer,
    setIsErrorModalOpened,
    handleSaveCareer,
    persistScore,
    persistSortDecision,
    handleBack,
    handleModalOpen,
    closeModal,
    handlescore,
    handleBook,
    closeSuccessModal,
    showLoader
  };
};

export default useResults;